import { Address } from './address.app';
import { PersonType } from './person-type.app';
import { User } from './user.app';

export interface Relative extends User {
	isSupervisor: boolean;
	remark?: string;
	otherText?: string;
	categoryPersonCategory: CategoryPersonCategory;
	personType: PersonType;
	categoryTypeOfCare?: CategoryTypeOfCare;
	address?: Address;
	hasBeenClarified: boolean;
	clarifiedAt?: Date;
	typeOfClarification?: CLARIFICATION_TYPE;
}

export interface CategoryPersonCategory {
	id: number;
	name: string;
	isInitiator?: boolean;
	isPersonal: boolean;
}

export interface CategoryTypeOfCare {
	integrationOfficeId?: number;
	id: number;
	remark?: string;
	initial?: string;
}

export interface CreateRelative {
	personCategoryId: number;
	remark: string;
	title?: string;
	genderId?: number;
	name: string;
	firstName: string;
	communicationWays?: CreateContactPoint[];
	isSupervised: boolean;
	otherText?: string;
	address?: Address;
	hasBeenClarified: boolean;
	clarifiedAt?: Date;
	typeOfClarification?: CLARIFICATION_TYPE;
}

export interface UpdateRelative {
	firstName?: string;
	lastName?: string;
	title?: string;
	otherText?: string;
	isSupervisor: boolean;
	genderId?: number;
	remark: string;
	personTypeId?: number;
	categoryPersonCategoryId?: number;
	categoryTypeOfCareId?: number;
	address?: Address;
	contactPoints?: CreateContactPoint[];
	hasBeenClarified: boolean;
	clarifiedAt?: Date;
	typeOfClarification?: CLARIFICATION_TYPE;
}

export interface CreateContactPoint {
	id?: number;
	categoryContactPointId?: number;
	contactValue?: string;
	preferredWayOfContact: boolean;
	remark?: string;
}

export enum CLARIFICATION_TYPE {
	PHONE = 0,
	IN_PERSON = 1,
	MAIL = 2,
}

export const CLARIFICATION_TYPE_OPTIONS = [
	{ value: CLARIFICATION_TYPE.PHONE, label: 'base.field.clarification_type_option.phone' },
	{ value: CLARIFICATION_TYPE.IN_PERSON, label: 'base.field.clarification_type_option.in_person' },
	{ value: CLARIFICATION_TYPE.MAIL, label: 'base.field.clarification_type_option.mail' },
] as const;

export function getClarificationTypeOptions() {
	return CLARIFICATION_TYPE_OPTIONS;
}

export interface ClarificationValue {
	hasBeenClarified: boolean;
	clarifiedAt?: Date;
	typeOfClarification?: CLARIFICATION_TYPE;
}

export enum CATEGORY_RELATIVE_INITIALS {
	RELATIVE_GENERIC = '', // Angehoerige
	SPOUSE = 'KAG01', // Ehemann/Ehefrau
	SIBLING = 'KAG02', // Bruder/Schwester
	PARENT = 'KAG03', // Vater/Mutter
	CHILD = 'KAG04', // Sohn/Tochter
	UNCLE_AUNT = 'KAG05', // Onkel/Tante
	COUSIN = 'KAG06', // Cousin/Cousine
	GRANDPARENT = 'KAG07', // Großvater/Großmutter
	GRANDCHILD = 'KAG08', // Enkel/-in
	PARTNER = 'KAG09', // Lebenspartner/-in
	TRUSTED_PERSON_OTHER = 'KAG99', // Sonstige Vertrauensperson
}
